import { useCallback, useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import WorkspaceTabBar from './WorkspaceTabBar';
import WorkspaceTabsSync from './WorkspaceTabsSync';
import './workspaceTabs.css';

const LIMIT_WARNING_MS = 6000;

/**
 * VS Code-style module tabs for the authenticated shell.
 * Place above the route <Outlet /> in private layouts.
 */
const WorkspaceTabs = () => {
  const [showLimitWarning, setShowLimitWarning] = useState(false);

  const handleLimitReached = useCallback(() => {
    setShowLimitWarning(true);
  }, []);

  useEffect(() => {
    if (!showLimitWarning) {
      return;
    }
    const timer = window.setTimeout(() => setShowLimitWarning(false), LIMIT_WARNING_MS);
    return () => window.clearTimeout(timer);
  }, [showLimitWarning]);

  return (
    <>
      <WorkspaceTabsSync onLimitReached={handleLimitReached} />
      <WorkspaceTabBar />
      {showLimitWarning && (
        <Alert
          variant="warning"
          className="workspace-tab-limit-alert"
          dismissible
          onClose={() => setShowLimitWarning(false)}
        >
          You have reached the limit of 10 open tabs. Close an existing tab to open another.
        </Alert>
      )}
    </>
  );
};

export default WorkspaceTabs;
